import { CHECKOUT } from '~/scopes/checkout/routes-names'
import { HOME } from '~/scopes/home/route-names'

type CheckoutStep =
  | 'cart'
  | 'addresses'
  | 'shipping'
  | 'payment'
  | 'insurance'
  | 'bouygues'

export const CHECKOUT_ACTIVE_STEPS: Record<string, CheckoutStep> = {
  [CHECKOUT.ADDRESS_CONFIRMATION]: 'shipping',
  [CHECKOUT.SHIPPING_ADDRESS]: 'shipping',
  [CHECKOUT.BILLING_ADDRESS]: 'shipping',
  [CHECKOUT.ADDRESSES]: 'addresses',
  [CHECKOUT.PAYMENT]: 'payment',
  [CHECKOUT.INSURANCE]: 'insurance',
  [CHECKOUT.SERVICES.BOUYGUES.SIGN_UP]: 'bouygues',
  [CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP]: 'bouygues',
}

export const CHECKOUT_PREVIOUS_ROUTES = {
  [CHECKOUT.CART]: HOME,
  [CHECKOUT.ADDRESS_CONFIRMATION]: CHECKOUT.CART,
  [CHECKOUT.SHIPPING_ADDRESS]: CHECKOUT.CART,
  [CHECKOUT.BILLING_ADDRESS]: CHECKOUT.CART,
  [CHECKOUT.PAYMENT]: CHECKOUT.ADDRESS_CONFIRMATION,
  [CHECKOUT.SERVICES.BOUYGUES.SIGN_UP]: CHECKOUT.ADDRESS_CONFIRMATION,
  [CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP]:
    CHECKOUT.SERVICES.BOUYGUES.SIGN_UP,
  [CHECKOUT.INSURANCE]: CHECKOUT.CART,
}

export const CHECKOUT_PREVIOUS_ROUTES_SINGLE_PAGE_ADDRESSES = {
  [CHECKOUT.CART]: HOME,
  [CHECKOUT.ADDRESSES]: CHECKOUT.CART,
  [CHECKOUT.PAYMENT]: CHECKOUT.ADDRESSES,
  [CHECKOUT.SERVICES.BOUYGUES.SIGN_UP]: CHECKOUT.ADDRESSES,
  [CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP]:
    CHECKOUT.SERVICES.BOUYGUES.SIGN_UP,
  [CHECKOUT.INSURANCE]: CHECKOUT.CART,
}
